/**
 * Roles API Service
 * Fetches reference user roles from Hasura GraphQL endpoint.
 * Token is read from localStorage (set during login) – never hardcoded.
 */

import { API_CONFIG } from '@/config/envConfig';
import type { ReferenceUserRole } from '@/types/dashboardConfig';

const GET_USER_ROLES_QUERY = `
  query GetUserRoles {
    reference_user_role {
      role
      role_id
    }
  }
`;

export async function getUserRoles(): Promise<ReferenceUserRole[]> {
  const hasuraToken =
    localStorage.getItem('hasuraToken') || localStorage.getItem('authToken') || '';

  if (!hasuraToken) {
    throw new Error('getUserRoles: No Hasura token available. Please log in.');
  }

  const endpoint = API_CONFIG.GRAPHQL_ENDPOINT;

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${hasuraToken}`,
    },
    body: JSON.stringify({ query: GET_USER_ROLES_QUERY, variables: {} }),
  });

  if (!response.ok) {
    throw new Error(`getUserRoles: HTTP ${response.status} ${response.statusText}`);
  }

  const json = await response.json();

  if (json.errors?.length) {
    throw new Error(`getUserRoles: GraphQL error – ${json.errors[0].message}`);
  }

  const roles: ReferenceUserRole[] =
    json?.data?.reference_user_role ?? [];

  return roles;
}
